import Link from 'next/link';

import CloudinaryImage from './CloudinaryImage';
import Container from './Container';

import './newherosectioncenter.css';
export default function NewHeroSectionCenter({ hero, setModalCall }) {
  const btnLength = hero?.banner_btn?.length ?? 0;
  return (
    <div className="bg-[#030C1E] xl:py-[100px] lg:py-[80px] py-[60px] text-center relative">
      {hero?.bgImage?.data?.attributes?.url && (
        <CloudinaryImage
          backendImgUrl={hero?.bgImage?.data?.attributes?.url}
          className={`absolute top-0 bottom-0 left-0 right-0 w-full z-[0] h-full object-cover`}
          alt={hero?.bgImage?.data?.attributes?.alternativeText}
          type="isTablet"
        />
      )}
      <Container className="relative z-[1]">
        <span className="block lg:text-[40px] md:text-[30px] text-[22px] font-[600] text-[#f9f9f9]">
          {hero?.title_bg}
        </span>
        <h1
          className={`xl:text-[80px] lg:text-[60px] md:text-[50px] text-[30px] font-[700] leading-tight gradientcolor ${hero?.p && 'mb-4'}`}
        >
          {hero?.h1_black}
        </h1>
        <p
          className={`lg:text-[30px] md:text-[20px] text-[16px] font-[500] text-[#ffffff] max-w-[1000px] mx-auto leading-tight ${btnLength && 'lg:mb-10 md:mb-5 mb-3'}`}
        >
          {hero?.p}
        </p>
        <div className="flex flex-wrap items-center justify-center">
          {hero?.banner_btn?.map((btn, key) =>
            btn?.link ? (
              <Link
                key={btn?.id}
                href={`${btn?.link}`}
                className={`${key % 2 === 0 && 'mr-3'} inline-block btnleftright mt-0 bg-[#0050D5] border-[1px] border-[#0050D5] font-[500] lg:text-[20px] text-[14px] text-[#fff] rounded-[4px] relative overflow-hidden lg:px-10 px-5 py-2`}
              >
                <span className="relative z-[5] transition duration-300 ease-in-out">
                  {btn?.text}
                </span>
              </Link>
            ) : (
              <button
                key={btn?.id}
                onClick={() => setModalCall(btn?.text)}
                className={`${key % 2 === 0 && 'mr-3'} btncolorleftright inline-block border-[1px] border-[#fff] text-[#fff] py-2 lg:px-10 px-5 lg:text-[20px] text-[14px] font-[500] relative overflow-hidden`}
              >
                <span className="relative z-[5] transition duration-300 ease-in-out">
                  {btn?.text}
                </span>
              </button>
            )
          )}
        </div>
      </Container>
    </div>
  );
}
